// extracted by mini-css-extract-plugin
export default {"header":"Scaffold_header__aPeON","back":"Scaffold_back__4jIbF","headerNoTopPadding":"Scaffold_headerNoTopPadding__cwYOY"};